import React from 'react';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

export interface MarketAdjustmentLedgerContextType {
  cellOptions: Record<string, ICell>;
}

const MarketAdjustmentLedgerContext = React.createContext<MarketAdjustmentLedgerContextType>({
  cellOptions: {},
});

export default MarketAdjustmentLedgerContext;
